<template>
    <div class="dropdown">
        <a
            href="#"
            ref="el"
            class="btn btn-tertiary dropdown-toggle"
            :class="{
                'ps-1': avatarMode,
                'btn-primary': buttonClass === 'primary',
                'btn-secondary': buttonClass === 'secondary',
                'btn-tertiary': buttonClass === 'tertiary',
                'd-flex': !noSelectedMode,
                'gap-1': !noSelectedMode,
                'align-items-center': !noSelectedMode
            }"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            v-html="noSelectedMode ? (customButtonHtml ? customButtonHtml : '') : buttonHtml"
        ></a>
        <ul class="dropdown-menu">
            <slot></slot>
        </ul>
    </div>
</template>

<script>
// Based on: https://dev.to/codeply/using-bootstrap-5-with-vue-js-5fnp
export default {
    name: 'Dropdown',

    props: {
        initialSelected: {
            default: null,
            required: false
        },
        avatarMode: {
            // Less padding
            default: false,
            required: false
        },
        noSelectedMode: {
            // Show just the dropdown arrow
            default: false,
            required: false
        },
        customButtonHtml: {
            default: null,
            required: false
        },
        buttonClass: {
            type: String,
            default: 'tertiary',
            validator(value) {
                return ['primary', 'secondary', 'tertiary'].includes(value);
            }
        }
    },

    data() {
        return {
            dropdown: null,
            buttonHtml: null,
            value: null
        }
    },

    emits: [
        'show',
        'shown',
        'hide',
        'hidden'
    ],

    mounted() {
        const { el } = this.$refs;

        this.dropdown = new window.bootstrap.Dropdown(el);

        this.$nextTick(() => {
            this.initialize();
        });

        // Events
        ['show', 'shown', 'hide', 'hidden'].forEach((eventName) => {
            el.addEventListener(`${eventName}.bs.dropdown`, (event) => {
                this.$emit(eventName, this.value || null);
            });
        });
    },

    methods: {
        initialize() {
            this.itemsChanged();

            // Set initial selected
            this.setSelected(this.initialSelected);
        },

        itemsChanged() {
            const { el } = this.$refs;

            // Setup events
            const dropdownItems = el.parentNode.querySelectorAll('.dropdown-item');
            for(let i = 0; i < dropdownItems.length; i++) {
                dropdownItems[i].removeEventListener('click', this.optionSelected);
                dropdownItems[i].addEventListener('click', this.optionSelected);
            }
        },

        optionSelected(event) {
            event.preventDefault();

            this.value = event.currentTarget.dataset.value;
            this.buttonHtml = event.currentTarget.innerHTML;
        },

        setSelected(value) {
            const { el } = this.$refs;
            this.value = value;

            const dropdownItems = el.parentNode.querySelectorAll('.dropdown-item');
            for(let i = 0; i < dropdownItems.length; i++) {
                // Set initial button HTML
                if(i === 0) {
                    this.buttonHtml = dropdownItems[i].innerHTML;
                }

                // Weak-match selected
                if(dropdownItems[i].dataset.value == value) {
                    this.buttonHtml = dropdownItems[i].innerHTML;
                }
            }
        }
    }
}
</script>
